import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { TokenService } from '../services/token.service';
import { ToastUtil } from '../../utils/toast.util';

/**
 * Restringe una ruta a los roles indicados en ``data.roles`` (nombres con prefijo
 * ``ROLE_``). Si el usuario no tiene ninguno, lo redirige a Top 100 (página visible
 * para todos los roles) y muestra un aviso. Ej.: Operador no accede a Usuarios ni
 * Entidades.
 */
export const roleGuard: CanActivateFn = (route) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const messageService = inject(MessageService);
  const translate = inject(TranslateService);

  const allowedRoles = (route.data['roles'] as string[] | undefined) ?? [];
  if (allowedRoles.length === 0 || tokenService.hasRole(allowedRoles)) {
    return true;
  }

  translate.get('app.errors.unauthorizedModule').subscribe((msg) => {
    ToastUtil.showError(messageService, msg);
  });

  router.navigate(['/top100']);
  return false;
};
